
import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { UserPermissions } from "@/store/types";
import eventsApi from "@/services/api.event.service";
import { EventLinkInfo } from "@/store/event-links/types";
import EventLinksTable from "@/components/event-links/EventLinksTable.vue";
import EventLinksMixin from "@/mixins/EventLinksMixin";

@Component({
	components: {
		"event-links-table": EventLinksTable,
	}
})
export default class EventLinkManager extends Mixins(EventLinksMixin) {
	@Getter("getPermissions") permissions: UserPermissions;

	private selectedEventId: number | null = null;

	private async linkEvent(): Promise<void> {
		if (!this.canEditEventLinkPermission) {
			return;
		}

		try {
			this.isLoading = true;
			await eventsApi.createEventLink(this.baseEventId, this.selectedEventId);
			await this.retrieveEventLinksList(true);
			await this.retrieveEventLinksTable(null, true);
		}
		catch (error) {
			console.error("Failed to create link: ", error);
		}
		finally {
			this.isLoading = false;
			this.selectedEventId = null;
		}
	}

	private async deleteLink(linkToDelete: EventLinkInfo): Promise<void> {
		try {
			this.isLoading = true;
			await eventsApi.deleteEventLink(this.baseEventId, linkToDelete.eventId);
			await this.retrieveEventLinksList(true);
			await this.retrieveEventLinksTable(null, true);
		}
		catch (error) {
			console.error("Failed to delete event link: ", error);
		}
		finally {
			this.isLoading = false;
		}
	}

	private get canEditEventLinkPermission(): boolean {
		return this.permissions.canEditEventLink;
	}

	private get linkEventButtonDisabled(): boolean {
		return !this.selectedEventId || this.selectedEventId < 1;
	}
}
